__turbopack_context__.v({
  "integrations-card-title": "IntegrationsCard-module__aXT8la__integrations-card-title",
});
